var Backbone, EmailFormLiveChatClickView, HelpWizardController, SupportContactChannelClickTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportContactChannelClickTemplate = require('../../../../contact_channel_click.html.mustache');

HelpWizardController = require("../../../helpWizardController");

Backbone = require('backbone');

Backbone.$ = $;

EmailFormLiveChatClickView = (function(superClass) {
  extend(EmailFormLiveChatClickView, superClass);

  function EmailFormLiveChatClickView() {
    return EmailFormLiveChatClickView.__super__.constructor.apply(this, arguments);
  }

  EmailFormLiveChatClickView.prototype.className = 'contact-channel-click-container';

  EmailFormLiveChatClickView.prototype.events = {
    'click #ChatSuccess': "chatsuccess",
    'click #otherContactChannel': "chooseDifferentContactChannel"
  };

  EmailFormLiveChatClickView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    return this.template = SupportContactChannelClickTemplate;
  };

  EmailFormLiveChatClickView.prototype.render = function() {
    return this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  EmailFormLiveChatClickView.prototype.toHash = function() {
    var hash;
    hash = {
      isChatClicked: true
    };
    return hash;
  };

  EmailFormLiveChatClickView.prototype.chatsuccess = function() {
    return Backbone.history.navigate('#chat-success', {
      trigger: true
    });
  };

  EmailFormLiveChatClickView.prototype.chooseDifferentContactChannel = function() {
    return HelpWizardController.stepThree();
  };

  return EmailFormLiveChatClickView;

})(Backbone.View);

module.exports = EmailFormLiveChatClickView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9jb21tb24vbGl2ZV9jaGF0X2NsaWNrX3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9jb21tb24vbGl2ZV9jaGF0X2NsaWNrX3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsOEZBQUE7RUFBQTs7O0FBQUEsa0NBQUEsR0FBcUMsT0FBQSxDQUFRLGlEQUFSOztBQUNyQyxvQkFBQSxHQUF1QixPQUFBLENBQVEsK0JBQVI7O0FBQ3ZCLFFBQUEsR0FBVyxPQUFBLENBQVEsVUFBUjs7QUFDWCxRQUFRLENBQUMsQ0FBVCxHQUFhOztBQUVQOzs7Ozs7O3VDQUNKLFNBQUEsR0FBVzs7dUNBRVgsTUFBQSxHQUNFO0lBQUEsb0JBQUEsRUFBdUIsYUFBdkI7SUFDQSw0QkFBQSxFQUErQiwrQkFEL0I7Ozt1Q0FJRixVQUFBLEdBQVksU0FBQTtJQUNWLElBQUMsQ0FBQSxTQUFELEdBQWE7V0FDYixJQUFDLENBQUEsUUFBRCxHQUFZO0VBRkY7O3VDQUlaLE1BQUEsR0FBUSxTQUFBO1dBQ04sSUFBQyxDQUFBLEdBQUcsQ0FBQyxJQUFMLENBQVUsTUFBQSxDQUFPLElBQUMsQ0FBQSxRQUFSLEVBQWtCLElBQUMsQ0FBQSxNQUFELENBQUEsQ0FBbEIsRUFBNkIsSUFBQyxDQUFBLFNBQTlCLENBQVY7RUFETTs7dUNBR1IsTUFBQSxHQUFRLFNBQUE7QUFDTixRQUFBO0lBQUEsSUFBQSxHQUNFO01BQUEsYUFBQSxFQUFlLElBQWY7O1dBQ0Y7RUFITTs7dUNBS1IsV0FBQSxHQUFhLFNBQUE7V0FDWCxRQUFRLENBQUMsT0FBTyxDQUFDLFFBQWpCLENBQTBCLGVBQTFCLEVBQTJDO01BQUMsT0FBQSxFQUFTLElBQVY7S0FBM0M7RUFEVzs7dUNBR2IsNkJBQUEsR0FBK0IsU0FBQTtXQUM3QixvQkFBb0IsQ0FBQyxTQUFyQixDQUFBO0VBRDZCOzs7O0dBdkJRLFFBQVEsQ0FBQzs7QUEwQmxELE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
